"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleCaughtError = exports.createClientErrors = exports.createClientError = exports.createError = exports.createNamedErrorClass = exports.ErrorWithStatusCode = exports.ExtendedGraphQLErrors = void 0;
const graphql_1 = require("graphql");
const enums_1 = require("./enums");
class ExtendedGraphQLErrors extends graphql_1.GraphQLError {
    constructor(errors) {
        super('Operation failed with one or more errors.');
        this.extensions = {
            code: 'EXTENDED_GRAPHQL_ERRORS',
            errors,
        };
    }
}
exports.ExtendedGraphQLErrors = ExtendedGraphQLErrors;
class ErrorWithStatusCode extends Error {
    constructor(message, name, statusCode = enums_1.ErrorStatusCode.INTERNAL_SERVER_ERROR) {
        super(message);
        this.name = name || this.constructor.name;
        this.statusCode = statusCode;
    }
}
exports.ErrorWithStatusCode = ErrorWithStatusCode;
/**
 * Factory function to create a simple named Error class.
 *
 * @param className class name
 * @param statusCode error status code
 */
const createNamedErrorClass = (className, errorStatusCode = enums_1.ErrorStatusCode.INTERNAL_SERVER_ERROR) => {
    const NewErrorClass = class extends ErrorWithStatusCode {
        constructor(message, name = className, statusCode = errorStatusCode) {
            super(message);
            this.name = name;
            this.statusCode = statusCode;
        }
    };
    // requires this for both class and instances to be properly named
    Object.defineProperty(NewErrorClass, 'name', { value: className });
    return NewErrorClass;
};
exports.createNamedErrorClass = createNamedErrorClass;
/**
 * Factory function to create one off named error for sentry. Named errors are useful for grouping errors in sentry and
 * improving the way they are displayed in Slack.
 *
 * @param name class name
 * @param message error message
 * @param statusCode error status code
 */
const createError = (name, message, statusCode) => new ((0, exports.createNamedErrorClass)(name, statusCode))(message);
exports.createError = createError;
const createClientError = (description, code = 'BAD_REQUEST', className = 'ExtendedGraphQLErrors') => {
    const error = new ExtendedGraphQLErrors([{ code, description }]);
    // requires this for both class and instances to be properly named in Sentry
    Object.defineProperty(error, 'name', { value: className });
    return error;
};
exports.createClientError = createClientError;
const createClientErrors = (errors, className = 'ExtendedGraphQLErrors') => {
    const error = new ExtendedGraphQLErrors(errors);
    // requires this for both class and instances to be properly named in Sentry
    Object.defineProperty(error, 'name', { value: className });
    return error;
};
exports.createClientErrors = createClientErrors;
/**
 * @param err error caught in a try/catch
 * @param expectedErrorClass class expected to be in the error's prototype chain
 * @param errorHandler function used to handle error if class expectedInPrototype is found in its prototype chain
 * @throws UnexpectedPrimitiveErrorType is error is a primitive type.
 */
const handleCaughtError = (err, expectedErrorClass, errorHandler) => {
    if (err instanceof expectedErrorClass) {
        return errorHandler(err);
    }
    console.error((0, exports.createError)('UnexpectedErrorType', err));
    throw (0, exports.createError)('UnexpectedErrorType', 'Please check logs for details.');
};
exports.handleCaughtError = handleCaughtError;
